(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$transitions', '$translate', 'LanguageService', 'translationHandler', 'UserData', 'RequestService', 'ModalConstructor'];

    function stateHandler($rootScope, $transitions, $translate, LanguageService, translationHandler, UserData, RequestService, ModalConstructor) {

        return {
            initialize: initialize
        };

        function initialize() {
            // Actions to execute when state change starts
            $transitions.onStart({
                to: function (state) {
                    return state.parent.name == 'app.private';
                }
            }, function (transition) {

                var $state = transition.router.stateService;

                // When loading the page for the first time try to get the
                // current user data to check if the user is already authenticated
                if (!UserData.isAuthenticated) {
                    // Get the current user data and authenticate
                    return UserData.getCurrentUser().catch(errorAuthentication);
                }

                // Function to execute when authentication fails
                function errorAuthentication() {
                    return $state.target('login');
                }

            });

            $transitions.onStart({to: 'login'}, function (transition) {

                var $state = transition.router.stateService;

                // Check if the user is already authenticated
                if (UserData.isAuthenticated) {
                    return false;
                } else if (!transition.redirectedFrom()) {
                    // Get the current user data and authenticate
                    return UserData.getCurrentUser().then(successAuthentication).catch(errorAuthentication);
                }

                // Function to execute when the user is authenticated
                function successAuthentication() {
                    // If it's on login page, redirect to olt
                    return $state.target('olt');
                }

                // Function to execute when authentication fails
                function errorAuthentication() {
                    return true;
                }

            });

            // Actions to execute when state change finishes
            $transitions.onSuccess({to: '*'}, function (transition) {

                var pageTitle = transition.to().data.pageTitle;

                // Set the page title key to the one configured in state or use default one
                var titleKey = pageTitle || 'global.title';
                translationHandler.updateTitle(titleKey);

                // Cancel the pending requests on the "request to be canceled" list
                RequestService.cancelRequests();
                $rootScope.$broadcast('requestsCanceled');

                // Update the language
                LanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });

                // Close all modals
                ModalConstructor.closeAll();

            });
        }
    }
})();
